import "styles/app.scss";

import React from "react";
import { CookiesProvider, withCookies } from "react-cookie";

import Schema from "components/Schema";
import { Header, Footer, ContactPopup } from "./components";
import AnimatedIntersection from "components/AnimatedIntersection";

import {
  useCategoriesQuery,
  useMainGlobalQuery,
  usePostsQuery,
  useQuizQuery,
} from "./hooks";

import PostsProvider from "context/posts";
import HamburgerProvider from "context/hamburger";
import MainGlobalProvider from "context/main-global";

const Layout = ({ children, showSchema, rework, page, bottomPadding }) => {
  const posts = usePostsQuery();
  const categories = useCategoriesQuery();
  const quiz = useQuizQuery();
  const mainGlobal = useMainGlobalQuery();

  return (
    <CookiesProvider>
      <PostsProvider value={posts} categories={categories} quiz={quiz}>
        <MainGlobalProvider data={mainGlobal}>
          <HamburgerProvider>
            {showSchema && <Schema />}
            {page ? (
              <>
                <AnimatedIntersection
                  id="header-page-gradient"
                  className="headers"
                  options={{ timeProgress: 0.76, seed: 11 }}
                  variant="blue-light"
                  backgroundColor="#fff"
                  isContainerless
                  isHero
                >
                  <main>{children}</main>
                </AnimatedIntersection>
                <Header page={page} />
              </>
            ) : (
              <>
                <main>{children}</main>
                <Header page={page} />
              </>
            )}
            <Footer bottomPadding={bottomPadding} />
            <ContactPopup />
          </HamburgerProvider>
        </MainGlobalProvider>
      </PostsProvider>
    </CookiesProvider>
  );
};

export default withCookies(Layout);
